var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[(_vm.displayBrand)?_c('branding'):_vm._e(),_c('v-progress-circular',{attrs:{"size":_vm.csize,"width":_vm.width,"color":"white","indeterminate":""}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }